export default {
    upgradeLine: 'อัปเดตไลน์',
    lineServiceIsUpdated: 'ระบบไลน์ถูกอัปเดตแล้ว',
    congratulation: 'ยินดีดัวย',
    description: 'อัปเดตไลน์เพื่อการแก้ไขข้อผิดพลาดหรือเพิ่มเติมฟีเจอร์</br>เช่น รีเฟรชเมนูใน LINE แอปพลิเคชัน',
    messageSent: 'จำนวนการส่งข้อความ'
}
